module.exports = __webpack_public_path__ + "img/image13.2e211e79.png";